<template>
  <div class="full-height">
    <photo-admin-header></photo-admin-header>
    <intro></intro>
    <section-intro :title="$t('message.title.site.photo_admin')"></section-intro>
    <photo-admin :car-id="$route.params.id"></photo-admin>
    <photo-admin-footer></photo-admin-footer>
  </div>
</template>

<script>
  import Intro from '../components/partials/IntroLarge'
  import PhotoAdminFooter from '../components/partials/Footer'
  import PhotoAdminHeader from '../components/partials/Header'
  import PhotoAdmin from '../components/car/PhotoAdmin'
  import SectionIntro from '../components/partials/SectionIntro'

  export default {
    components: { Intro, PhotoAdminFooter, PhotoAdminHeader, PhotoAdmin, SectionIntro }
  }
</script>



// WEBPACK FOOTER //
// CarPhotoAdmin.vue?1df97c08